var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.58039 18H11.4196C13.1427 18 14 17.1184 14 15.3722V7.74913C14 6.66591 13.8835 6.19594 13.2176 5.50746L8.62295 0.797731C7.99082 0.142567 7.47446 0 6.53407 0H2.58039C0.865811 0 0 0.889791 0 2.63642V15.3722C0 17.1267 0.865811 18 2.58039 18ZM2.6468 16.6485C1.78951 16.6485 1.33991 16.1864 1.33991 15.3471V2.66149C1.33991 1.83045 1.78951 1.35152 2.65532 1.35152H6.35082V6.22961C6.35082 7.2874 6.88352 7.80788 7.91553 7.80788H12.6601V15.3471C12.6601 16.1864 12.2187 16.6485 11.3532 16.6485H2.6468ZM8.0654 6.53982C7.74081 6.53982 7.60728 6.40585 7.60728 6.06985V1.61194L12.4016 6.54018L8.0654 6.53982Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.35a6fd089d2ad303bd54fd99ad57f262.svg";
export { ForwardRef as ReactComponent };